export default function PlaceholderGridItem({
    columnClassesForGrid = "",
    ...props
}) {
    const className = [
        "card w-100 mb-0 bg-light-subtle shadow-sm text-decoration-none placeholder-glow border-0 p-0 rounded",
        columnClassesForGrid,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={className} style={{ width: "18rem" }} {...props}>
            <div className="placeholder card-img-top" style={{ height: "280px" }} />
            <div className="placeholder-glow card-body">
                <h5 className="card-title">
                    <span
                        className="placeholder rounded"
                        style={{ width: "50%", height: "2rem" }}
                    />
                </h5>
                <p className="card-text">
                    <span
                        className="placeholder rounded"
                        style={{ width: "80%", height: "2.5rem" }}
                    />
                </p>
            </div>
        </div>
    );
}
